const compact = typeof Intl !== 'undefined' && Intl.NumberFormat
    ? new Intl.NumberFormat(undefined, { notation: 'compact', maximumFractionDigits: 1 })
    : null;
const full = typeof Intl !== 'undefined' && Intl.NumberFormat ? new Intl.NumberFormat() : null;

export const formatCount = n => {
    if (typeof n !== 'number' || Number.isNaN(n)) return '';
    return compact ? compact.format(n) : String(n);
}

export const formatFullCount = n => {
    if (typeof n !== 'number' || Number.isNaN(n)) return '';
    return full ? full.format(n) : String(n);
}
